"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "v-inline-input-editor",
    props: {
        component: {
            type: Function,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true
        }
    },
    beforeMount: function () {
        this.$options.components.component = this.component;
    },
    data: function () {
        return {
            state: "value",
            _value: this.value
        };
    },
    watch: {
        value: function () {
            this.$data._value = this.value;
        }
    },
    methods: {
        switchState: function (resetValue) {
            if (resetValue === void 0) { resetValue = false; }
            if (this.canEdit) {
                if (resetValue) {
                    this.$data._value = this.value;
                }
                this.state = (this.state === "value") ? "component" : "value";
            }
        },
        onInputKeyDown: function (keyCode) {
            if (keyCode === 13) {
                if (!this.$refs["inputComponent"].isValid(true)) {
                    this.$refs["inputComponent"].appendValidationClass();
                    return;
                }
                this.switchState();
                this.$emit("update", this.$data._value);
            }
        },
        onInput: function (value) {
            this.$data._value = value;
        }
    }
});
